

        <app-type-desc-marche  [uid]="getUid()" [parentForm]="parentForm" [description]="rectificatif.description"></app-type-desc-marche>

    